import { useEffect } from 'react';
import useRestaurant from '@lo/shared/hooks/useRestaurant';

const useSaveRestaurantReference = () => {
    const restaurant = useRestaurant();
    const restaurantReference = restaurant.reference;

    useEffect(() => {
        if (restaurantReference && !localStorage.getItem('selectedRestaurantId')) {
            localStorage.setItem('selectedRestaurantId', restaurantReference);
        }
    }, [restaurantReference]);
};

export default useSaveRestaurantReference;
